import { AccountData, PaymentCapabilitiesData } from '../../api';
import { useAuth } from '../../session/InternalAuthProvider';

export const usePaymentCapabilities = (): Required<PaymentCapabilitiesData> => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData | null;

  return {
    saved_cards: account?.payment_integration_settings?.capabilities?.saved_cards ?? false,
    recurring_passes: account?.payment_integration_settings?.capabilities?.recurring_passes ?? false,
    refunds: account?.payment_integration_settings?.capabilities?.refunds ?? false,
    card_readers: account?.payment_integration_settings?.capabilities?.card_readers ?? false,
    sales_tax_locked: account?.payment_integration_settings?.capabilities?.sales_tax_locked ?? false,
  };
};
